import {GearIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

interface DiffViewSettingsProps {
  isUnifiedDiff: boolean
  setIsUnifiedDiff: (isUnified: boolean) => void
}

export function DiffViewSettings({isUnifiedDiff, setIsUnifiedDiff}: DiffViewSettingsProps) {
  return (
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton icon={GearIcon} aria-label="Open diff view settings" variant="invisible" />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList>
          <ActionList.Group selectionVariant="single">
            <ActionList.GroupHeading>Layout</ActionList.GroupHeading>
            <ActionList.Item selected={isUnifiedDiff} onSelect={() => setIsUnifiedDiff(true)}>
              Unified
            </ActionList.Item>
            <ActionList.Item selected={!isUnifiedDiff} onSelect={() => setIsUnifiedDiff(false)}>
              Split
            </ActionList.Item>
          </ActionList.Group>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
